import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { getManagers} from "../../../actions/actionManager";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Manager",path:"/managers",isActive: false},
    {name: "ViewManager",path:"/viewmanager",isActive: true},
];

class ViewManager extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentManager: null
        };
    }
  
    componentDidMount(){
        this.props.getManagers();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.managers.length > 0){        	
            let currentManager = nextProps.managers.find(manager => manager.manager_id === this.props.match.params.id);
            this.setState({currentManager: currentManager});
        }
    }


    render(){
        const {currentManager} = this.state;
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View Manager</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div>
                                            {currentManager?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>Manager Id</td><td>{currentManager.manager_id}</td></tr>
                                                        <tr><td>Hostname</td><td>{currentManager.manager_hostname}</td></tr>
                                                        <tr><td>Zone</td><td>{currentManager.zone_name}</td></tr>
                                                        <tr><td>Version</td><td>{currentManager.manager_version}</td></tr>
                                                        <tr><td>First Reported Time</td><td>{moment(currentManager.first_reported).format("L h:mm A")}</td></tr>
                                                        <tr><td>Last Reported</td><td>{currentManager.last_reported_elapsed}</td></tr>
                                                        <tr><td>Last Reported Time</td><td>{moment(currentManager.last_reported).format("L h:mm A")}</td></tr>
                                                        <tr><td>Agents</td><td className="word-wrap"><ReactJson src={currentManager.servers}
                                                            name={false}
                                                            collapsed={true}
                                                            sortKeys={true}
                                                            collapseStringsAfterLength={40}
                                                            enableClipboard={false}
                                                            displayDataTypes={false}
                                                        /></td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewManager.propTypes = {
    getManagers: Proptypes.func.isRequired,
    managers: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        managers: state.managers.managers || []
    }),
dispatch => 
    ({  
        getManagers: () => dispatch(getManagers()),
    }))(ViewManager);


// WEBPACK FOOTER //
// ./src/views/Managers/ViewManager/ViewManager.js